module.exports = __webpack_public_path__ + "img/but6.d9835c54.png";